import keymirror from 'keymirror';

export default keymirror({
  insertImageIntoEditor: null,
  insertVideoIntoEditor: null,
  insertLinkIntoEditor: null,
  insertImageLinkIntoEditor: null,
  textEditorCustomLineHeight: null,
});
